export default __webpack_public_path__ + "static/FAM20731000-80f15a26d9acc2e1ba0bc928dd0cfd18.jpg";